// @ts-nocheck
import { name2num, num2name, } from "./DurationType";
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "./(ProductTemplate)/ProductSelectOptionTemplate";
import { encodeJson as encodeJson_2, decodeJson as decodeJson_2, encodeBinary as encodeBinary_2, decodeBinary as decodeBinary_2, } from "./SaleConfig";
import { encodeJson as encodeJson_3, decodeJson as decodeJson_3, encodeBinary as encodeBinary_3, decodeBinary as decodeBinary_3, } from "./(ProductTemplate)/PaymentConfigTemplate";
import { encodeJson as encodeJson_4, decodeJson as decodeJson_4, encodeBinary as encodeBinary_4, decodeBinary as decodeBinary_4, } from "./DisplayConfig";
import { name2num as name2num_1, num2name as num2name_1, } from "./ProductCategory";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { default as Long, } from "../../../../runtime/Long";
import { tsValueToWireValueFns, unpackFns, } from "../../../../runtime/wire/scalar";
import { encodeBinary as encodeBinary_5, decodeBinary as decodeBinary_5, } from "../../../google/protobuf/Int64Value";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        durationType: "DURATION_TYPE_UNSPECIFIED",
        defaultGoodsIds: [],
        selectOptions: [],
        saleConfig: undefined,
        paymentConfig: undefined,
        displayConfig: undefined,
        category: "PRODUCT_CATEGORY_UNSPECIFIED",
        durationAmount: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    var _a;
    const result = {};
    if (value.durationType !== undefined)
        result.durationType = tsValueToJsonValueFns.enum(value.durationType);
    result.defaultGoodsIds = value.defaultGoodsIds.map(value => tsValueToJsonValueFns.int64(value));
    result.selectOptions = value.selectOptions.map(value => encodeJson_1(value));
    if (value.saleConfig !== undefined)
        result.saleConfig = encodeJson_2(value.saleConfig);
    if (value.paymentConfig !== undefined)
        result.paymentConfig = encodeJson_3(value.paymentConfig);
    if (value.displayConfig !== undefined)
        result.displayConfig = encodeJson_4(value.displayConfig);
    if (value.category !== undefined)
        result.category = tsValueToJsonValueFns.enum(value.category);
    switch ((_a = value.durationAmount) === null || _a === void 0 ? void 0 : _a.field) {
        case "days": {
            result.days = value.durationAmount.value;
            break;
        }
        case "months": {
            result.months = value.durationAmount.value;
            break;
        }
    }
    return result;
}
export function decodeJson(value) {
    var _a, _b, _c, _d;
    const result = getDefaultValue();
    if (value.durationType !== undefined)
        result.durationType = jsonValueToTsValueFns.enum(value.durationType);
    result.defaultGoodsIds = (_b = (_a = value.defaultGoodsIds) === null || _a === void 0 ? void 0 : _a.map((value) => jsonValueToTsValueFns.int64(value))) !== null && _b !== void 0 ? _b : [];
    result.selectOptions = (_d = (_c = value.selectOptions) === null || _c === void 0 ? void 0 : _c.map((value) => decodeJson_1(value))) !== null && _d !== void 0 ? _d : [];
    if (value.saleConfig !== undefined)
        result.saleConfig = decodeJson_2(value.saleConfig);
    if (value.paymentConfig !== undefined)
        result.paymentConfig = decodeJson_3(value.paymentConfig);
    if (value.displayConfig !== undefined)
        result.displayConfig = decodeJson_4(value.displayConfig);
    if (value.category !== undefined)
        result.category = jsonValueToTsValueFns.enum(value.category);
    if (value.days !== undefined)
        result.durationAmount = { field: "days", value: value.days };
    if (value.months !== undefined)
        result.durationAmount = { field: "months", value: value.months };
    return result;
}
export function encodeBinary(value) {
    var _a;
    const result = [];
    if (value.durationType !== undefined) {
        const tsValue = value.durationType;
        result.push([1, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    for (const tsValue of value.defaultGoodsIds) {
        result.push([3, tsValueToWireValueFns.int64(tsValue)]);
    }
    for (const tsValue of value.selectOptions) {
        result.push([4, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.saleConfig !== undefined) {
        const tsValue = value.saleConfig;
        result.push([5, { type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }]);
    }
    if (value.paymentConfig !== undefined) {
        const tsValue = value.paymentConfig;
        result.push([6, { type: WireType.LengthDelimited, value: encodeBinary_3(tsValue) }]);
    }
    if (value.displayConfig !== undefined) {
        const tsValue = value.displayConfig;
        result.push([7, { type: WireType.LengthDelimited, value: encodeBinary_4(tsValue) }]);
    }
    if (value.category !== undefined) {
        const tsValue = value.category;
        result.push([8, { type: WireType.Varint, value: new Long(name2num_1[tsValue]) }]);
    }
    switch ((_a = value.durationAmount) === null || _a === void 0 ? void 0 : _a.field) {
        case "days": {
            const tsValue = value.durationAmount.value;
            result.push([2, ((tsValue) => ({ type: WireType.LengthDelimited, value: encodeBinary_5(tsValue) }))({ value: tsValue })]);
            break;
        }
        case "months": {
            const tsValue = value.durationAmount.value;
            result.push([9, ((tsValue) => ({ type: WireType.LengthDelimited, value: encodeBinary_5(tsValue) }))({ value: tsValue })]);
            break;
        }
    }
    return serialize(result);
}
const oneofFieldNumbersMap = {
    durationAmount: new Set([2, 9]),
};
const oneofFieldNamesMap = {
    durationAmount: new Map([
        [2, "days"],
        [9, "months"],
    ]),
};
export function decodeBinary(binary) {
    var _a;
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    const wireFieldNumbers = Array.from(wireFields.keys()).reverse();
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.durationType = value;
    }
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 3).map(([, wireValue]) => wireValue);
        const value = Array.from(unpackFns.int64(wireValues));
        if (!value.length)
            break collection;
        result.defaultGoodsIds = value;
    }
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 4).map(([, wireValue]) => wireValue);
        const value = wireValues.map((wireValue) => wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined).filter(x => x !== undefined);
        if (!value.length)
            break collection;
        result.selectOptions = value;
    }
    field: {
        const wireValue = wireFields.get(5);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.saleConfig = value;
    }
    field: {
        const wireValue = wireFields.get(6);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_3(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.paymentConfig = value;
    }
    field: {
        const wireValue = wireFields.get(7);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_4(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.displayConfig = value;
    }
    field: {
        const wireValue = wireFields.get(8);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name_1[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.category = value;
    }
    oneof: {
        const oneofFieldNumbers = oneofFieldNumbersMap.durationAmount;
        const oneofFieldNames = oneofFieldNamesMap.durationAmount;
        const fieldNumber = wireFieldNumbers.find(v => oneofFieldNumbers.has(v));
        if (fieldNumber == null)
            break oneof;
        const wireValue = wireFields.get(fieldNumber);
        const wireValueToTsValueMap = {
            [2](wireValue) { var _a; return (_a = (wireValue.type === WireType.LengthDelimited ? decodeBinary_5(wireValue.value) : undefined)) === null || _a === void 0 ? void 0 : _a.value; },
            [9](wireValue) { var _a; return (_a = (wireValue.type === WireType.LengthDelimited ? decodeBinary_5(wireValue.value) : undefined)) === null || _a === void 0 ? void 0 : _a.value; },
        };
        const value = (_a = wireValueToTsValueMap[fieldNumber]) === null || _a === void 0 ? void 0 : _a.call(wireValueToTsValueMap, wireValue);
        if (value === undefined)
            break oneof;
        result.durationAmount = { field: oneofFieldNames.get(fieldNumber), value: value };
    }
    return result;
}
